import { Permiso } from './../../../../../../_entities/Enums/permiso.enum';
import { ToastrService } from 'ngx-toastr';
import { GeocercasService } from './../../../../services/geocercas.service';
import { MapaService } from './../../../../services/mapa.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { CategoriasComponent } from '../categorias/categorias.component';


@Component({
	selector: 'kt-geocerca-modal',
	templateUrl: './geocerca-modal.component.html',
	styleUrls: ['./geocerca-modal.component.scss']
})
export class GeocercaModalComponent implements OnInit {
	@ViewChild('gridContainer', { static: false }) gridContainer: ElementRef;
	public geoCercas: any[];
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public currentFilter: any;
	public permisoConsultarGeocercas: string;
	public permisoAgregarGeocerca: string;
	public permisoActualizarGeocerca: string;
	public permisoEliminarGeocerca: string;
	public permisoCategoriaGeocerca:string;
	 isDisabled: boolean = true;
	public datosReporte = [];

	public header = 'Descripción';


	constructor(public dialogRef: MatDialogRef<GeocercaModalComponent>,
		private mapaServicio: MapaService,
		private geoService: GeocercasService,
		private toastr: ToastrService,
		private dialog:MatDialog) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;

	}

	async ngOnInit() {
		console.log('´´');

		await this.obtenerGeoCercas();
		this.obtenerPermisoGeoCercas();
	}

	devExtreme() {
	}

	agregar() {
		this.dialogRef.close();
		this.mapaServicio.agregarGeoCerca();
	}


	obtenerGeoCercas() {
		this.geoService.getGeoCercas().subscribe((res: any[]) => {
			this.geoCercas = res;
			this.geoCercas.forEach(geocerca => {
				if(geocerca.descripcion == 'NA'){
					geocerca.descripcion = geocerca.categoriaNombre;
					this.header = 'Categoría';
				}

				this.datosReporte.push({
					'Nombre': geocerca.nombre,
					'Descripción': geocerca.descripcion
				});
			});
			if (this.datosReporte.length > 0) {
				this.isDisabled = false;
			}
		}, err => {
			this.toastr.error('Error', err)
		});
	}

	verGoeCerca(data: any) {
		this.mapaServicio.ubicarGeocerca(data);
	}

	eliminarGoeCerca(data: any) {
		Swal.fire({
			title: 'Eliminar',
			text: `¿Está seguro que desea eliminar la geocerca ${data.nombre}?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Confirmar',
			cancelButtonText: "Cancelar"
		}).then((result) => {
			if (result.value) {
				this.geoService.deleteGeoCerca(data.id).subscribe(() => {
					Swal.fire(
						'Eliminado!',
						'La geocerca ha sido eliminada.',
						'success'
					).then((resultok) => { if (resultok.value) location.reload(); });
				}, err => {
					Swal.fire(
						'Ops!',
						'Error al intentar eliminar la geocerca.',
						'error'
					);
				});
			}
		})

	}

	updateGoeCerca(data: any) {
		this.mapaServicio.ubicarGeocerca(data);
		this.mapaServicio.updateGeocerca();
		this.dialogRef.close();
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

	/**Obtener permisos de geocercas */
	public get Permiso() {
		return Permiso;
	}

	obtenerPermisoGeoCercas() {
		this.permisoConsultarGeocercas = Permiso.VisualizarGeocercas;
		this.permisoAgregarGeocerca = Permiso.AgregarGeocerca;
		this.permisoActualizarGeocerca = Permiso.ActualizarGeocerca;
		this.permisoEliminarGeocerca = Permiso.EliminarGeocerca;
		this.permisoCategoriaGeocerca = Permiso.CategoriasGeocerca;
	}


	abrirModalCategoria(){
		this.dialog.open(CategoriasComponent).afterClosed().subscribe(result=>{
			this.obtenerGeoCercas();
		  })
	}
}
